import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { Router } from "@angular/router";

import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as moment from "moment";
import * as _ from "lodash";
import { Loan, LoanPaymentDetail } from "../../../models/loan.model";
import { UserService } from "../../../@core/services/user.service";
import { LoanService } from "../../../services/loan.service";
import { DialogLoanComponent } from "../../dialogs/dialog-loan/dialog-loan.component";
import Shop from "../../../models/shop.model";
import { User } from "../../../@core/data/users";
import { Catalog } from "../../../models/product.model";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "ngx-view-loan-remind",
  styleUrls: ["./view-loan-remind.component.scss"],
  templateUrl: "./view-loan-remind.component.html",
})
export class ViewLoanRemindComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() remind: LoanPaymentDetail;

  @Input() mode?: string = ""; //today / incomplete / planning / completed
  @Input() isMore? = false;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() groupLoans?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];

  @Output() onPayment: EventEmitter<any> = new EventEmitter();
  @Output() onRemove: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isMobile = false;

  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    public userService: UserService,
    private loanService: LoanService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId;
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.remind.issueDate = this.remind.issueDate
      ? moment(this.remind.issueDate).toDate()
      : new Date();

    if (this.remind.loan.customer) {
      this.remind.loan.customer.cardIdDate = this.remind.loan.customer
        ?.cardIdDate
        ? convertTimestamp(this.remind.loan.customer.cardIdDate)
        : new Date();
    } else {
      this.remind.loan.customer = {
        fullName: "",
        address: "",
        mobile: "",
        cardId: "",
        cardIdDate: new Date(),
      };
    }

    // this.remind.loan.customer.cardIdDate = this.remind.loan.customer?.cardIdDate
    //   ? moment(this.remind.loan.customer.cardIdDate).toDate()
    //   : new Date();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get remindTypeName(): string {
    let str = "";
    const remindPaidNumber = this.remind.loan.remindPaidNumber
      ? this.remind.loan.remindPaidNumber
      : 1;

    str += remindPaidNumber === 1 ? "hằng " : "mỗi " + remindPaidNumber + " ";

    switch (this.remind.loan.remindType) {
      case "day":
        str += "ngày";
        break;
      case "week":
        str += "tuần";
        break;
      case "month":
      default:
        str += "tháng";
        break;
      case "year":
        str += "năm";
        break;
    }

    return str;
  }

  loadContent(value) {
    this.isMore = value;
  }

  viewDetail(item) {
    if (this.mode === "remind") {
      this.getLoan(item.id);
    } else if (this.mode !== "view") {
      this.openDialogLoan(item);
    }
  }

  private getLoan(id) {
    this.loading = true;
    this.loanService
      .getLoan(this.shopId, id)
      .then((doc) => {
        console.log("getLoan:", doc.data());

        if (doc.exists) {
          let loan: Loan = new Loan();
          loan = doc.data();
          loan.id = id;
          loan.createdOn = convertTimestamp(loan.createdOn);
          loan.issueDate = convertTimestamp(loan.issueDate);
          loan.remindDate = convertTimestamp(loan.remindDate);
          loan.updatedOn = convertTimestamp(loan.updatedOn);

          loan.customer.cardIdDate = loan.customer.cardIdDate
            ? convertTimestamp(loan.customer.cardIdDate)
            : new Date();

          this.openDialogLoan(loan);
        }
        this.loading = false;
      })
      .catch((err) => {
        console.log("getLoan/err:", err);
        this.loading = false;
      });
  }

  private openDialogLoan(item: Loan) {
    const loan = _.clone(item);
    this.dialogService
      .open(DialogLoanComponent, {
        context: {
          header: "Tạo phiếu cầm đồ",
          mode: "edit",
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          loan: loan,
          groupLoans: this.groupLoans,
          categories: this.categories,
          colors: this.colors,
          menu: "detail",
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          if (value.isDeleted) {
            item = value;
            this.onRemove.emit(this.remind);
          }
        }
      });
  }

  payment() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Đơn hàng đã được gia hạn thành công?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;
          this.remind.isPaid = true;
          this.remind.paymentDate = new Date();
          this.remind.amount = parseFloat(this.remind.amount.toString());
          this.loanService
            .saveLoanRemindPaid(this.remind)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onPayment.emit(this.remind);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  remove() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa gia hạn này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.loanService
            .deleteLoanRemindPaid(this.remind.shopId, this.remind.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.remind.isDeleted = true;
              this.onRemove.emit(this.remind);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }
}
